import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const serviceRateTypeEnums = [
   'Per month',
   'Per annum',
   'One-time fee',
   'Per session',
   'Per unit'
] as const

export enum serviceRateTypeEnumsLabels {
   'Per month' = 'Monthly fees',
   'Per annum' = 'Annual fees',
   'One-time fee' = 'One-time fees',
   'Per session' = 'Session fees',
   'Per unit' = 'Unit fees'
}

export const ServiceRatePeriodSuffix: Record<ServiceRateTypeEnum, string | undefined> = {
   "Per annum": '/y' ,
   "Per month": '/m',
   "One-time fee": undefined,
   "Per session": undefined,
   "Per unit": undefined,
}

export const paymentMethodOptionValues = ['monthly-instalments', 'annual', 'upfront', 'staged', 'on-completion'] as const
export const PaymentMethodOptionValueSchema = z.enum(paymentMethodOptionValues)
export type PaymentMethodOptionValue = z.infer<typeof PaymentMethodOptionValueSchema>
export const ServiceRateTypeEnumSchema = z.enum(serviceRateTypeEnums, { errorMap })
export type ServiceRateTypeEnum = z.output<typeof ServiceRateTypeEnumSchema>
